module.exports = __webpack_public_path__ + "static/media/insurance.970258e4.png";